import {
  SignalBlockTarget,
  TemplateConfigInput,
  TemplateType
} from '@server/trading-templates/schemas/input.schema';
import { Subject } from 'rxjs';
import { useCallback, useMemo } from 'react';

export type TemplateApplyMode = 'add' | 'replace';

type TemplateAppliedPayload = {
  templateId: string;
  templateName: string;
  templateType: TemplateType;
  timeframeIndex: number;
  strategyTarget?: SignalBlockTarget;
  applyMode: TemplateApplyMode;
  templateConfig: TemplateConfigInput;
};

const templateAppliedSubject = new Subject<TemplateAppliedPayload>();

export const useTemplateEvents = () => {
  const templateApplied$ = useMemo(
    () => templateAppliedSubject.asObservable(),
    []
  );

  const emitTemplateApplied = useCallback((payload: TemplateAppliedPayload) => {
    templateAppliedSubject.next(payload);
  }, []);

  return {
    templateApplied$,
    emitTemplateApplied
  };
};
